/**
 * Dashboard API Service
 * Handles all dashboard-related API calls
 */

import axiosInstance from '@/lib/axios'
import API_ROUTES from '@/lib/api-routes'
import type { DashboardStats, DashboardStatsResponse } from '@/types/dashboard'

/**
 * Get Dashboard Stats
 * GET /dashboard/admin
 */
export const getDashboardStats = async (): Promise<DashboardStats> => {
    const response = await axiosInstance.get<DashboardStatsResponse>(
        API_ROUTES.DASHBOARD.ADMIN
    )
    return response.data.data
}
